

import { Routes, Route } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css'
import sanga3 from "../../assets/omria.jpg";
import omria2 from "../../assets/camb (8).jpg";
import omria3 from "../../assets/omriacut.jpg"
import crack3 from "../../assets/crack (10).jpg"
import crack4 from "../../assets/crack (2).jpg"
import crack5 from "../../assets/crack (3).jpg"
import crack6 from "../../assets/crack (4).jpg"
import crack7 from "../../assets/crack (5).jpg"
import crack8 from "../../assets/crack (6).jpg"
import crack9 from "../../assets/crack (7).jpg"
import crack10 from "../../assets/crack (9).jpg"
import crack11 from "../../assets/crack (8).jpg"
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from "../../config";

// Video path from public folder for proper streaming
const videoUrl = "/videos/vedio.mp4";

export default function Umbria() {
  const { t, i18n } = useTranslation();
  const images = [sanga3, omria2, omria3, crack3, crack4, crack5, crack6, crack7,
    crack8, crack9, crack10, crack11];


  useEffect(() => {
    Aos.init({ duration: 1000 });
  });

  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    people: "",
    phone: "",
    date: "",
    passport: null,
    tribname: "Umbria"
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "passport" && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstname.trim() || !formData.people.trim() || !formData.phone.trim()
      || !formData.date.trim() || !formData.passport) {
      alert("فضلاً املئي كل الحقول");
      return;
    }

    const data = {
      firstname: formData.firstname,
      people: formData.people,
      phone: formData.phone,
      date: formData.date,
      passport: formData.passport?.name || "uploaded",
      tribname: formData.tribname
    };

    try {
      await axios.post(`${API_URL}/booking`, data);
      alert('تم الحجز بنجاح ✅');
      setFormData({ firstname: "", people: "", phone: "", date: "", passport: null, tribname: "Umbria" });
      setPreview(null);
    }
    catch (err) {
      console.log(err);
      alert("حدث خطأ: " + (err.response?.data?.error || err.message));
    }
  };

  const [price, setPrice] = useState([]);
  useEffect(() => {
    async function getPrice() {
      try {
        const responce = await axios.get(`${API_URL}/prices`);
        setPrice(responce.data);
      }
      catch (error) {
        console.error(error)
      }
    } getPrice();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  };

  return (

    <div className="" >
      <style>
        {`
          @keyframes floatShip {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-40px); }
          }
        `}
      </style>
<div className="w-screen h-full relative" >
        <video autoPlay loop muted playsInline preload="metadata" className=' hidden lg:block  w-full h-full object-cover'>
          <source src={videoUrl} type="video/mp4"></source>
        </video>

        <div className='lg:absolute gap-6  inset-0 bg-black/40 flex  flex-col items-center justify-center lg:flex-row'>

          <video autoPlay loop muted playsInline preload="metadata" className='lg:hidden w-full h-full absolute  top-0 object-cover '>
            <source src={videoUrl} type="video/mp4"></source>
          </video>

          <div data-aos="fade-right"
            className="text-yellow-700 lg:relative  flex items-center flex-col rtl h-full p-4 lg:m-6 justify-center" >
            <h1 className="text-white  text-6xl md:text-6xl font-bold">{t("umbriah")}</h1>
            <h3 className="text-white  text-xl md:text-xl font-bold p-4"> {t("hero2")}</h3>
          </div>

          <form onSubmit={handleSubmit} data-aos="fade-left"
            className="mx-4 rounded-[20px] w-full max-w-[500px]
  mx-w-md mx-auto mt-10 p-4  items-center 
 justify-center bg-black/50 text-white mb-0"  >
            <div className="space-y-12">
              {price.filter((el) => el.id === "4").map((item) => (<div className="border-b border-gray-900/10 justify-centet items-center">
                <h2 className="text-base/7 font-semibold text-white justify-center items-center">{t("bookUmbria")}</h2>

                <h2 className="text-base/7 font-semibold text-white justify-center items-center">${item.price}</h2>

                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("name")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='text' value={formData.firstname} id="first-name" name="firstname" autocomplete="given-name"
                        className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium ">{t("phone")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autocomplete="phone" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>


                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("date3")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='date' value={formData.date} id="first-name" name="date" autocomplete="given-name" className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium ">{t("people")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="text" value={formData.people} name="people" autocomplete="" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>



                  <div className="sm:col-span-6">
                    <div className="border-b border-gray-900/10 pb-12">
                      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="col-span-full">
                          <label htmlFor="cover-photo" className="block text-sm/6 font-medium">{t("photo")}</label>
                          <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25">
                            <div className="text-center">

                              <div className="mt-4 flex text-sm/6 text-gray-600">
                                <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold
                 text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 
    ]focus-within:outline-hidden hover:text-indigo-500">
                                  <span>Upload a file</span>
                                  <input type="file" name="passport" onChange={handleChange} accept='image/*' />
                                  {preview && (
                                    <img
                                      src={preview}
                                      alt="passport preview"
                                      className="mt-4 w-20 h-20 object-cover rounded-md"
                                    />
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>))}
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">

              <button type="submit" className="rounded-md w-full bg-blue-400 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-blue-600">Send</button>
            </div>
          </form>
        </div>
      </div>

      <div className='relative my-10 font-serif  text-gray-600 '>
        <div data-aos="fade-up" className=" w-full flex flex-col md:flex-row-reverse items-center">
          <img src={sanga3} className='md:w-[30%] w-full' />
          <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left flex flex-col justify-center  overflow-auto px-6">
            <h2 className="text-xl p-4 md:font-bold ">{t("umbriahead")}</h2>
            <p className='first-letter:float-left first-letter:text-6xl 
first-letter:leading-[0.85] first-letter:me-3 first-letter:mt-1 first-letter:font-bold'>
              {t("umbriastory1")}
            </p>
          </div>
        </div>
        <div data-aos="fade-up" className="w-full flex flex-col 
md:flex-row-reverse items-center gap-4 p-4 ">

          <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
            <p className='first-letter:float-left first-letter:text-6xl 
first-letter:leading-[0.85] first-letter:me-3 first-letter:mt-1 first-letter:font-bold'>
              {t("umbriastory3")}
            </p>
          </div>

          <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1  overflow-auto px-6">
            <p className='first-letter:float-left first-letter:text-6xl 
first-letter:leading-[0.85] first-letter:me-3 first-letter:mt-1 first-letter:font-bold'>
              {t("umbriastory2")}
            </p>
          </div>
        </div>
      </div>

      <div className="relative w-full  flex items-center justify-center ">

        <video data-aos="fade-up" loop controls playsInline preload="metadata"
          className="w-[80%] h-[80%] rounded-lg" >
          <source src={videoUrl} type="video/mp4"></source>
        </video>

        <button className="absolute text-white text-5xl z-10 animate-pulse">
          <i className="fas fa-play"></i>
        </button>

        <span className="absolute w-20 h-20 rounded-full border-4 border-blue opacity-70 animate-ping"></span>
        <span className="absolute w-20 h-20 rounded-full border-4 border-blue opacity-50 animate-ping delay-200"></span>
        <span className="absolute w-20 h-20 rounded-full border-4 border-blue opacity-30 animate-ping delay-500"></span>

      </div>

      <div className='w-full  my-10  rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>Umbria Crack</h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className='rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 mb-4'/>
          ))}
        </div></div>


    </div>
  );

}


